import React from 'react';
import ranchBottle from '../assets/ranch-bottle.jpg';
import waterDisc from '../assets/water-disc2.png';
import bottleCutout from '../assets/ranch-bottle-photo-cut3.png';
import config from '../config';

function Header() {
  const popClass = config.logoIntro ? 'rtr-pop' : '';

  return (
    <header style={{ textAlign: 'center', marginBottom: 24 }}>
      {/* Layered hero: base photo + spinning water disc + static bottle cutout */}
      <div
        className={`rtr-toplogo ${popClass}`}
        style={{ position: 'relative', width: 300, maxWidth: '100%', margin: '0 auto 20px' }}
      >
        <img
          src={ranchBottle}
          alt="Ranch bottle"
          style={{ display: 'block', width: '100%', height: 'auto', borderRadius: 12 }}
        />
        {/* Squashed wrapper reads the disc as a pool in perspective; inner image spins */}
        <div
          style={{
            position: 'absolute',
            left: '50.27%',
            top: '88.58%',
            width: '77.45%',
            aspectRatio: '1 / 1',
            transform: 'translate(-50%,-50%) scaleY(0.1632)',
            pointerEvents: 'none',
          }}
        >
          <img
            className="rtr-spinwater"
            src={waterDisc}
            alt=""
            style={{ display: 'block', width: '100%', height: '100%', borderRadius: '50%' }}
          />
        </div>
        {/* Static bottle cutout keeps the bottle still while water spins beneath */}
        <img
          src={bottleCutout}
          alt=""
          style={{
            position: 'absolute',
            left: '43.95%',
            top: '13.70%',
            width: '20.79%',
            height: 'auto',
            pointerEvents: 'none',
          }}
        />
      </div>

      <h1
        style={{
          margin: 0,
          fontSize: 34,
          lineHeight: '40px',
          fontWeight: 700,
          letterSpacing: '-0.02em',
          color: '#f5f5f7',
        }}
      >
        Rate the Ranch
      </h1>
      <p style={{ fontSize: 16, color: '#aeaeb2', margin: '8px 0 0' }}>
        Because not all ranch is created equal
      </p>
    </header>
  );
}

export default Header;
